module.exports = __webpack_public_path__ + "img/荣誉证书06_杨浦区科技小巨人.9fe5c396.png";